import React from 'react';
import { Container } from 'react-bootstrap';

const NotFoundPage = () => (
  <Container fluid className="page-wrapper flex-fill">
    <div>404 Page not found.</div>
  </Container>
);

export default NotFoundPage;